
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website } from '@/services/Website/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class WebsiteSearchResults extends Vue {
  @Prop({ type: Array, required: true })
  public websites!: Website[];

  @Prop({ type: Number, required: true })
  public count!: number;

  @Prop({ type: Number, required: true })
  public page!: number;

  @Prop({ type: Number, required: true })
  public pageSize!: number;

  @Prop({ type: String, default: '' })
  public queryLabel!: string;

  @Prop({ type: Boolean, default: false })
  public loadingMore!: boolean;

  public get canLoadMore(): boolean {
    return this.websites.length < this.count;
  }
}
